<template>
  <div class="content">
    <div class="calendar-header">
      <i class="iconfont icon-jiantou_liebiaoxiangzuo_o" @click="changeMoth(-1)"></i>
      <span>{{ month }}</span>
      <i class="iconfont icon-jiantou_liebiaoxiangyou_o" @click="changeMoth(1)"></i>
    </div>
    <div class="calendar-body">
      <div class="item" v-for="(item, ind) in list" :key="'c' + ind">
        <div v-if="item.dailyDate" class="item-ctt"
          :class="{ isSelect: ind === currentIndex, 'item-click': item.dailyId }" @click="changeDay(item.dailyId, ind)">
          <p class="date"><span>{{ item.dailyDate.split('-')[2] }}</span></p>
          <p class="ctt">
            <img v-if="item.dailyId.length" src="@/assets/img/workPlan/rl.png" alt="">
          </p>
        </div>
        <div v-else class="item-ctt">
          <p class="date"></p>
          <p class="ctt"></p>
        </div>
      </div>
    </div>
    <ReportDetail :dailyId="dailyId" :isShow.sync="showDetail"></ReportDetail>
  </div>
</template>

<script>
import ReportDetail from './ReportDetail'
export default {
  name: 'DailyReport',
  components: { ReportDetail },
  data() {
    return {
      month: this.$dayjs().format('YYYY-MM'),
      currentIndex: -1,
      showDetail: false,
      list: []
    }
  },
  watch: {
    projectId() {
      this.load()
    }
  },
  computed: {
    projectId() {
      return this.$store.state.projectId || ''
    },
    dailyId() {
      if (
        this.currentIndex >= 0 &&
        this.list[this.currentIndex] &&
        this.list[this.currentIndex].dailyId &&
        this.list[this.currentIndex].dailyId.length
      ) {
        return this.list[this.currentIndex].dailyId;
      }
      return [];
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.currentIndex = -1
      this.$axios.get(this.$apis.workPlan.selectProjectDailySum, {
        projectId: this.projectId,
        yearMonth: this.month
      }).then((res) => {
        this.formatList(res.list || [])
      })
    },
    formatList(arr) {
      this.list = arr
      let startLen = this.$dayjs(this.month).day() - 1
      startLen = startLen === -1 ? 6 : startLen
      const totalLen = this.list.length + startLen > 35 ? 42 : 35
      const aStart = new Array(startLen)
      const aEnd = new Array(totalLen - this.list.length - startLen)
      aStart.length && aStart.fill({})
      aEnd.length && aEnd.fill({})
      this.list = aStart.concat(this.list)
      this.list = this.list.concat(aEnd)
    },
    changeMoth(num) {
      this.month = this.$dayjs(this.month).add(num, 'month').format('YYYY-MM')
      this.load()
    },
    changeDay(dailyId, ind) {
      if (dailyId) {
        if (this.currentIndex !== ind) {
          this.currentIndex = ind
        }
        this.showDetail = true
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.content {
  .calendar-header {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      padding: 0 20px;
    }

    .iconfont {
      cursor: pointer;
    }
  }

  .calendar-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid #EFEFEF;
    margin-top: 10px;

    .item {
      flex-shrink: 0;
      width: 14.28%;

      .item-click {
        cursor: pointer;
      }

      .item-ctt {
        border: 1px solid #EFEFEF;
        border-bottom-color: transparent;

        p {
          padding: 0 5px;
          line-height: 18px;

          &.date {
            width: 100%;
            height: 18px;
            color: rgba(0, 0, 0, 0.8);
            background: #F3F3F3;

            span {
              opacity: 0.5;
            }
          }

          &.ctt {
            display: flex;
            justify-content: right;
            align-items: flex-end;
            height: 36px;
            padding: 5px;

            img {
              width: 14px;
              height: 14px;
            }
          }
        }

        &.isSelect {
          .date {
            color: #000000;
            background: #E0EEFF;
          }

          border-color: #1B85FF;
        }
      }

      &:first-child,
      &+.item:not(:nth-child(7n)) {
        .item-ctt:not(.isSelect) {
          border-right-width: 0;
        }
      }
    }
  }
}
</style>
